import React, { useRef, useCallback, SetStateAction, Dispatch } from "react";
import { base64ToBlob, fileToBase64, openPdfInNewTab } from "../../utils/processPdfDocument";
import { Button, Icon } from "@jarvis-catalyst/ui-components";
import { ConsentChildrenType } from "../../types";
import { NewVersionConsentConfigType } from "../../types/newVersionConsentConfig";

type UpdateAndPreviewPdfProps = {
  consent: NewVersionConsentConfigType | ConsentChildrenType;
  pdfViewerAttributes: {
    title: string;
    content: string;
  };
  setPdfViewerAttributes: Dispatch<
    SetStateAction<{
      title: string;
      content: string;
    }>
  >;
};

export const UpdateAndPreviewPdf: React.FC<UpdateAndPreviewPdfProps> = ({
  consent,
  pdfViewerAttributes,
  setPdfViewerAttributes
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleButtonClick = () => fileInputRef.current?.click();

  const changeUploadPdf = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = event.target;
      if (!files?.length) return;

      const file: File = files[0];
      const fileConvertedToBase64: string = await fileToBase64(file);
      const blobUrl: string = base64ToBlob(fileConvertedToBase64);

      setPdfViewerAttributes({
        title: file.name,
        content: blobUrl
      });

      consent.pdf = {
        name: file.name,
        content: fileConvertedToBase64.split(",")[1]
      };
    },
    [consent, setPdfViewerAttributes]
  );

  const isDocumentLoaded = Boolean(pdfViewerAttributes.content);

  return (
    <div className="mt-3">
      {isDocumentLoaded && (
        <div className="alert alert-success" role="alert" color="success">
          El archivo <strong>{pdfViewerAttributes.title}</strong> se ha cargado con éxito.
        </div>
      )}
      <div className="row">
        <div className="col d-grid gap-2">
          <input type="file" accept="application/pdf" ref={fileInputRef} onChange={changeUploadPdf} hidden />
          <Button
            type="button"
            onClick={handleButtonClick}
            title={
              !isDocumentLoaded
                ? "Seleccione un archivo.pdf"
                : `Se ha cargado el archivo ${pdfViewerAttributes.title}`
            }
            className="text-center"
          >
            {`${!isDocumentLoaded ? "Seleccionar" : "Actualizar"} archivo`}
          </Button>
        </div>
        {isDocumentLoaded && (
          <div className="col">
            <Button
              type="button"
              onClick={() => openPdfInNewTab(pdfViewerAttributes.content)}
              title={`Previsualizar ${pdfViewerAttributes.title}`}
            >
              <Icon name="View" color="white" size={16} />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
